import { ErrorCode } from '@/api/types/pt_enums'
import { PtError } from '@/types/pt_types'
import * as logUtil from '@/utils/log'
import { formatErrMsg } from '@/utils/string'

import type { IInterceptor } from '@/axios/IInterceptor'
import type { AxiosResponse, InternalAxiosRequestConfig } from 'axios'

class CommonInterceptor implements IInterceptor {
  /**
   * 请求发出之前处理请求配置
   * @param config 请求配置
   */
  beforeRequest = async (config: InternalAxiosRequestConfig<any>): Promise<InternalAxiosRequestConfig<any>> => {
    return config
  }

  /**
   * 处理请求错误
   * @param error 请求错误信息
   */
  handleRequestError = (error: any): any => {
    logUtil.error(`common handle request error: ${JSON.stringify(error)}`)
    return Promise.reject(new PtError((error as any).code || 499, formatErrMsg(error)))
  }

  /**
   * 服务器响应请求成功
   * @param response 响应体(不要返回其它类型避免影响其它拦截器)
   */
  onResponseSucceed = async (response: AxiosResponse): Promise<AxiosResponse> => {
    if (response.status !== 200) {
      return Promise.reject(new PtError(ErrorCode.SVR_ERR.value, response.statusText ?? '请求错误'))
    }
    return response
  }

  /**
   * 服务器响应请求失败
   * @param error 响应错误信息
   */
  onResponseFailed = (error: any): any => {
    logUtil.error(`common handle response failed: ${JSON.stringify(error)}`)
    return Promise.reject(new PtError((error as any).code || 599, formatErrMsg(error)))
  }
}

export default CommonInterceptor
